import { Cubit } from 'blac';
import { toast } from 'react-toastify';
import { ICardsCubit } from '../../interfaces/interfaces';
import i18n from '../../translations/i18n';
import firebase from '../../utils/firebase';

const db = firebase.ref('/Cards');

export default class CardsCubit extends Cubit<ICardsCubit> {
    constructor() {
        super({ cardId: '', json: {} });
    }

    public readonly findCard = async (userId = this.state.cardId) => {
        let response;
        await db.child(userId).once('value', function (snapshot: any) {
            response = snapshot.val();
        });

        if (!response) {
            this.emit({ cardId: this.state.cardId, json: {} });
        } else {
            this.emit({ cardId: this.state.cardId, json: response });
        }
    };

    public readonly setCardId = async (value: string) => {
        this.emit({ cardId: value, json: this.state.json });
    };

    public readonly setJson = async (value: object) => {
        this.emit({ cardId: this.state.cardId, json: value });
    };

    public readonly updateCard = async (key = this.state.cardId, value = this.state.json) => {
        await db
            .child(key)
            .set(value)
            .then((e: any) => {
                toast.success(i18n.t(`${e}`) as string);
            })
            .catch((e: any) => {
                toast.error(e);
                console.log(e);
            });
    };
}
